import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, DialogTitleProps, IconButton, Stack, Toolbar } from '@mui/material';
import React from 'react';

/** Note: this file contains components from the Dialog
 * that need more than just styles
 * */

interface UIDialogTitleProps extends DialogTitleProps {
  title: string;
  startIcon?: React.ReactElement;
  onCloseBtnAction?: () => void;
}

export const UIDialogTitle: React.FC<UIDialogTitleProps> = ({
  title,
  startIcon,
  onCloseBtnAction,
  ...props
}) => {
  return (
    <Toolbar sx={{
      justifyContent: 'space-between',
      alignItems: 'center',
    }}>
      <Stack direction='row' sx={{ alignItems: 'center' }}>
        {startIcon && (
          <>{startIcon}</>
        )}
        <DialogTitle
          {...props}
          variant='h6'
          sx={{
            paddingLeft: 'initial',
            fontWeight: 600,
            ...props.sx,
          }}
        >
          {title}
        </DialogTitle>
      </Stack>

      {onCloseBtnAction && (
        <IconButton
          size='small'
          onClick={onCloseBtnAction}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Toolbar>
  );
};